// extracted by mini-css-extract-plugin
export var alignLeft = "H_qh d_fp d_bG d_dv";
export var alignCenter = "H_bP d_fq d_bD d_dw";
export var alignRight = "H_qj d_fr d_bH d_dx";
export var comparisonComponentContentEqual = "H_h9 d_h9 d_b1 d_w d_bz d_bF d_bJ d_w";
export var comparisonComponentEqual = "H_jc d_jc d_w d_y d_cX";
export var positioner = "H_tt";
export var wrapper = "H_qm d_c8";